export const dataPreloaderCa = {
    title_1: "SEGUEIX ENDAVANT NOMÉS SI ETS MAJOR D'EDAT",
    button: 'ACCEDIR',
    title_2: 'WELCOME TO',
    logo: '/assets/images/el-secreto-logo.svg',
}